import CardMenu from "components/card/CardMenu";
import Card from "components/card";
import * as XLSX from "xlsx";
import { RiFileExcel2Line } from "react-icons/ri";
import { IoPrintOutline } from "react-icons/io5";
import React, { useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { StockReport } from "../../../Redux/Report/action";
import ReactToPrint from "react-to-print";
import StockPrint from "../../../views/Print/StockPrint";
import { FaSearch } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MdOutlineFilterAlt, MdOutlineFilterAltOff } from "react-icons/md";

const StockReportpage = () => {
  const parseDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day} ${month} ${year}`;
  };
  

  // const formatDate = (dateString) => {
  //   const [day, month, year] = dateString.split(" ");
  //   return `${year}-${month}-${day}`;
  // };
  const formattedDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const [tableData, settableData] = useState([])
const [Filter, setFilter] = useState(false)

  const TempleID = JSON.parse(localStorage.getItem("Sopanam_TempleId"));
  const stocklist = useSelector((state) => state?.Report?.stock)|| [];
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState(new Date());
  // const [ToDate, setToDate] = useState("");

  const dispatch = useDispatch();

useEffect(() => {
  if(ToDate){
    settableData(stocklist)
  }

}, [stocklist])

const [filters, setFilters] = useState({
  Name: '',
  OpeningStock: '',
  StockInHands: '',
  startDate: '',
  ClosingStock: '',
});
const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters({
    ...filters,
    [name]: value,
  });
};
const [filteredData, setFilteredData] = useState(tableData);
useEffect(() => {
  // console.log("filteredData",filteredData);
  
}, [filteredData])

useEffect(() => {
  // console.log("filters", filters);

  const filtered = tableData?.length > 0 && tableData.filter((item) => {
    return (
      (!filters.Name || item.Name.toLowerCase().includes(filters.Name.toLowerCase())) &&
      (!filters.OpeningStock || item.OpeningStock.toString().includes(filters.OpeningStock)) &&
      (!filters.StockInHands || item.StockInHands?.toString().includes(filters.StockInHands)) &&
      (!filters.ClosingStock || item.ClosingStock?.toString().includes(filters.ClosingStock))
    );
  });

  setFilteredData(filtered);
}, [filters, tableData]);


useEffect(() => {
  if(ToDate){
    HandelSearchByDate()
  }
}, [])


  const HandelSearchByDate = () => {
    dispatch(
      StockReport({
        TempleId: TempleID,

        ToDate:formattedDate(ToDate),
      })
    );
  };

  const OpeningStockvalue =
    stocklist.length &&
    stocklist?.reduce((total, item) => total + item.OpeningStockValue, 0);
  const StockInHands =
    stocklist.length &&
    stocklist?.reduce((total, item) => total + item.StockInHands, 0);
  const ClosingStock =
    stocklist.length &&
    stocklist?.reduce((total, item) => total + item.ClosingStock, 0);

  const exportToExcel = () => {
    let newArray = stocklist.map((obj) => {
      let newObj = { ...obj };

      delete newObj.Id;
      return newObj;
    });
 

  

    const dataArray = newArray.map((item) => Object.values(item));

    
    

    const headers = [
      "S.No",
      "Name",
      "Opening Stock",
      "Opening Stock Value ",
      "Issue Quantity",
      "Issue Return",
      "Purchase Quantity",
      "Purchase Return",
      "Damage Quantity",
      "average",
      "Stock In Hands",
      "Closing Stock",
    ];

    const wsData = [
      headers,
      ...dataArray.map((item, index) => [
        index + 1,
        stocklist[index].Name,
        stocklist[index].OpeningStock,
        stocklist[index].OpeningStockValue,
        stocklist[index].SaleQuantity,
        stocklist[index].IssueReturn,
        stocklist[index].PurchaseQuantity,
        stocklist[index].PurchaseReturn,
        stocklist[index].DamageQuantity,
        stocklist[index].average,
        stocklist[index].StockInHands,
        stocklist[index].ClosingStock,
      ]),
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "Stock Report.xlsx");
  };
const totals = {
  OpeningStock: 0,
  OpeningStockValue: 0,
  SaleQuantity: 0,
  IssueReturn: 0,
  PurchaseQuantity: 0,
  PurchaseReturn: 0,
  DamageQuantity: 0,
  average: 0,
  StockInHands: 0,
  ClosingStock: 0,
};

stocklist.forEach((item) => {
  totals.OpeningStock += item.OpeningStock || 0;
  totals.OpeningStockValue += item.OpeningStockValue || 0;
  totals.SaleQuantity += item.SaleQuantity || 0;
  totals.IssueReturn += item.IssueReturn || 0;
  totals.PurchaseQuantity += item.PurchaseQuantity || 0;
  totals.PurchaseReturn += item.PurchaseReturn || 0;
  totals.DamageQuantity += item.DamageQuantity || 0;
  totals.average += item.average || 0;
  totals.StockInHands += item.StockInHands || 0;
  totals.ClosingStock += item.ClosingStock || 0;
});
  const componentRef = React.useRef();

  return (
    <div>
      <StockPrint ref={componentRef} stocklist={stocklist} />
      <Card extra={"w-full h-full p-4"}>
        <div className="relative flex items-center justify-between">
          <div className="flex w-full pb-5 text-xl font-bold text-navy-700 dark:text-white">
            Stock
            <div className="flex w-full justify-end">
            
              <div className="mr-3 mt-2"></div>
              <div>
               <DatePicker
                  selected={ToDate}
                  onChange={(date) => setToDate(date)}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Select a date"
                  maxDate={new Date()} // This will disable future dates
                  className="mr-2 appearance-none rounded-md border border-gray-300 bg-white px-4 py-2 leading-tight text-gray-700 focus:border-blue-500 focus:bg-white focus:outline-none"
                />
              </div>
              <div>
                <button
                  onClick={HandelSearchByDate}
                  className="text-red hover:before:bg-redborder-red-500 relative h-[40px] w-40 overflow-hidden border border-blue-500 bg-white px-3 text-blue-500 shadow-2xl transition-all before:absolute before:bottom-0 before:left-0 before:top-0 before:z-0 before:h-full before:w-0 before:bg-blue-500 before:transition-all before:duration-500 hover:text-white hover:shadow-blue-500 hover:before:left-0 hover:before:w-full mr-2"
                >
                  <span className="flex relative z-10 mx-auto w-fit">
                    Search <FaSearch className="ml-1 mt-1 " />
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div>
            <button size={24} className="mr-5" onClick={exportToExcel}>
              <RiFileExcel2Line size={24} color="green" />
            </button>
            <ReactToPrint
              trigger={() => (
                <button type="button" className="PrintButton margin">
                  <IoPrintOutline size={24} color="blue" />
                </button>
              )}
              content={() => componentRef.current}
            />
          </div>
        </div>
        <div className="flex justify-end  w-full">{Filter?<MdOutlineFilterAltOff size={28} onClick={()=>{setFilter(false)}}/>:<MdOutlineFilterAlt size={28} onClick={()=>{setFilter(true)}}/>}</div>
        {Filter?<div> <div className="mb-4 grid grid-cols-4 gap-4">
        <input
          type="text"
          name="Name"
          value={filters.Name}
          onChange={handleFilterChange}
          placeholder="Filter by Name"
          className="border p-2"
        />
        <input
          type="text"
          name="OpeningStock"
          value={filters.OpeningStock}
          onChange={handleFilterChange}
          placeholder="Filter by Opening stock"
          className="border p-2"
        />
        <input
          type="text"
          name="StockInHands"
          value={filters.StockInHands}
          onChange={handleFilterChange}
          placeholder="Filter by Stock In Hand"
          className="border p-2"
        />
        <input
          type="text"
          name="ClosingStock"
          value={filters.ClosingStock}
          onChange={handleFilterChange}
          placeholder="Filter by Closing stock"
          className="border p-2"
        />
      </div>
</div>:''}
        <div className="h-full md:h-[585px] md:overflow-y-auto ">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-left text-sm text-gray-500 dark:text-gray-400 rtl:text-right">
              <thead className="bg-gray-50 text-xs uppercase text-gray-700 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    SL NO 
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Name
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Opening Stock
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Opening Stock Value
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Issue Quantity
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Issue Return
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Purchase Quantity
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Purchase Return
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Damage Quantity
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Average
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Stock In Hand
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Closing Stock Value
                  </th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(filteredData) &&
                  filteredData.map((item, index) => (
                    <tr
                      key={index}
                      className={`border-b ${
                        index % 2 === 0
                          ? "even:bg-gray-50 dark:bg-gray-800"
                          : "odd:bg-white"
                      } ${
                        index % 2 === 0
                          ? "even:bg-gray-800 dark:bg-gray-800"
                          : "odd:bg-gray-900"
                      }`}
                    >
                      <td className="px-6 py-4 text-gray-900">{index + 1}</td>
                      <td className="px-6 py-4 text-gray-900">{item.Name}</td>
                      <td className="px-6 py-4 text-gray-900">
                        {item.OpeningStock}
                      </td>
                      <td className="px-6 py-4 text-gray-900">
                      {item.OpeningStockValue ? item.OpeningStockValue.toFixed(2) : "0.00"}

                      </td>
                      <td className="px-6 py-4 text-gray-900">
                        {item.SaleQuantity ? item.SaleQuantity.toFixed(3) : "0.000"}
                      </td>
                      <td className="px-6 py-4 text-gray-900">
                      {item.IssueReturn ? item.IssueReturn.toFixed(3) : "0.000"}

                      </td>
                      <td className="px-6 py-4 text-gray-900">
                        {item.PurchaseQuantity? item.PurchaseQuantity.toFixed(3) : "0.000"}
                      </td>
                      <td className="px-6 py-4 text-gray-900">
                        {item.PurchaseReturn? item.PurchaseReturn.toFixed(3) : "0.000"}
                      </td>
                      <td className="px-6 py-4 text-gray-900">
                        {item.DamageQuantity ? item.DamageQuantity.toFixed(3) : "0.000"}
                      </td>
                      
                      <td className="px-6 py-4 text-gray-900">
                      {item.average?item.average.toFixed(2):'0.00'}
                      </td>
                      <td className="px-6 py-4 font-bold text-gray-900">
                      {item.StockInHands ? item.StockInHands.toFixed(3) : "0.000"}

                      </td>
                      <td className="px-6 py-4 font-bold text-gray-900">
                      {item.ClosingStock ? item.ClosingStock.toFixed(2) : "0.00"}

                      </td>
                    </tr>
                  ))}
               <tr className="bg-gray-100 font-bold text-gray-900">
                    <td colSpan={2} className="px-6 py-4 text-left">
                      Total
                    </td>
                    <td className="px-6 py-4">{totals.OpeningStock.toFixed(2)}</td>
                    <td className="px-6 py-4">{totals.OpeningStockValue.toFixed(2)}</td>
                    <td className="px-6 py-4">{totals.SaleQuantity.toFixed(3)}</td>
                    <td className="px-6 py-4">{totals.IssueReturn.toFixed(3)}</td>
                    <td className="px-6 py-4">{totals.PurchaseQuantity.toFixed(3)}</td>
                    <td className="px-6 py-4">{totals.PurchaseReturn.toFixed(3)}</td>
                    <td className="px-6 py-4">{totals.DamageQuantity.toFixed(3)}</td>
                    <td className="px-6 py-4">{totals.average.toFixed(2)}</td>
                    <td className="px-6 py-4">{totals.StockInHands.toFixed(3)}</td>
                    <td className="px-6 py-4">{totals.ClosingStock.toFixed(2)}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default StockReportpage;
